import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import setLotToAvailable from '../Agreement/setLotToAvailable.api';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function updateLot(
	lotId,
	{ salesAgent, coBroker, lotAvailability, closingDate, lotPrice },
	alteredBy
) {
	let oldValues;
	let lotRef = firebaseRef.ref('/kavtek_lots/' + projectCode + '/' + lotId);
	let timestampRef = firebaseRef.ref(
		'/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation'
	);

	await lotRef.once('value', (snapshot) => {
		oldValues = {
			lotPrice: snapshot.val()?.lotPrice,
		};
	});

	if (lotAvailability === 'available') {
		console.log('lotAvkailability 27', lotAvailability);
		let setLotToAvailableFunc = firebase
			.functions()
			.httpsCallable('setLotToAvailable');

		await setLotToAvailableFunc({
			lotId: lotId,
			projectCode: PROJECT_CODE.projectCode,
		});
	}

	await lotRef.update({
		assignedSalesAgent: salesAgent ? salesAgent : null,
		assignedCoBroker: coBroker ? coBroker : null,
		available: lotAvailability ? lotAvailability : null,
		closingDate: closingDate ? closingDate : null,
		lotPrice: lotPrice ? lotPrice : lotPrice === 0 ? 0 : null,
	});

	if (oldValues.lotPrice !== lotPrice) {
		let timestamp = timestampRef.push();
		await timestamp.set({
			timestamp: Date.now(),
			value: 'lotPrice',
			oldValue: oldValues.lotPrice
				? oldValues?.lotPrice
				: oldValues?.lotPrice === 0
				? 0
				: '',
			newValue: lotPrice ? lotPrice : lotPrice === 0 ? 0 : '',
			lotId: lotId,
			alteredBy: alteredBy,
		});
	}
}

export async function updateLots(
	lotIdArr,
	{ salesAgent, coBroker, lotAvailability, closingDate, lotPriceChange },
	alteredBy
) {
	lotIdArr.map(async (lotId) => {
		let lotRef = firebaseRef.ref(
			'/kavtek_lots/' + projectCode + '/' + lotId
		);
		let lotPrice;
		await lotRef.once('value', (snapshot) => {
			lotPrice = snapshot.val().lotPrice;
		});

		let finalLotPrice =
			(lotPrice ? Number(lotPrice) : 0) + Number(lotPriceChange);

		if (salesAgent) {
			await lotRef.update({
				assignedSalesAgent: salesAgent,
			});
		}
		if (coBroker) {
			await lotRef.update({
				assignedCoBroker: coBroker,
			});
		}
		if (lotAvailability) {
			await lotRef.update({
				available: lotAvailability,
			});

			if (lotAvailability === 'available') {
				let setLotToAvailableFunc = firebase
					.functions()
					.httpsCallable('setLotToAvailable');

				await setLotToAvailableFunc({
					lotId: lotId,
					projectCode: PROJECT_CODE.projectCode,
				});
			}
		}
		if (closingDate) {
			await lotRef.update({
				closingDate: closingDate,
			});
		}
		if (lotPriceChange !== 0) {
			await lotRef.update({
				lotPrice: finalLotPrice,
			});

			let timestampRef = firebaseRef.ref(
				'/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation'
			);
			let timestamp = timestampRef.push();
			await timestamp.set({
				timestamp: Date.now(),
				value: 'lotPrice',
				oldValue: lotPrice ? lotPrice : lotPrice === 0 ? 0 : '',
				newValue: finalLotPrice
					? finalLotPrice
					: finalLotPrice === 0
					? 0
					: '',
				lotId: lotId,
				alteredBy: alteredBy,
			});
		}
	});
}

export async function updateLotPricing(
	lotId,
	{
		lotSizeType,
		lotPremiumPrice,
		lotUpgradePrice,
		lotPrice,
		lotAvailability,
		closingDate,
	},
	alteredBy
) {
	let oldValues;
	let lotRef = firebaseRef.ref('/kavtek_lots/' + projectCode + '/' + lotId);
	let timestampRef = firebaseRef.ref(
		'/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation'
	);

	let pricing;
	let pricingArr = [];
	await lotRef.once('value', (snapshot) => {
		pricing = snapshot.val().pricing;
		oldValues = {
			lotPrice: snapshot.val()?.lotPrice,
		};
	});
	if (pricing) {
		pricingArr = pricing;
		if (lotUpgradePrice) {
			let index = pricingArr.findIndex(
				(element) => element.name === 'WOB'
			);
			if (index >= 0) {
				pricingArr[index].price = lotUpgradePrice;
			} else {
				pricingArr.push({
					name: 'WOB',
					price: lotUpgradePrice,
				});
			}
		} else {
			let index = pricingArr.findIndex(
				(element) => element.name === 'WOB'
			);
			if (index >= 0) {
				pricingArr[index].price = 0;
			} else {
				pricingArr.push({
					name: 'WOB',
					price: 0,
				});
			}
		}
		if (lotPremiumPrice) {
			let index = pricingArr.findIndex(
				(element) => element.name === 'Lot Premium'
			);
			if (index >= 0) {
				pricingArr[index].price = lotPremiumPrice;
			} else {
				pricingArr.push({
					name: 'Lot Premium',
					price: lotPremiumPrice,
				});
			}
		} else {
			let index = pricingArr.findIndex(
				(element) => element.name === 'Lot Premium'
			);
			if (index >= 0) {
				pricingArr[index].price = 0;
			} else {
				pricingArr.push({
					name: 'Lot Premium',
					price: 0,
				});
			}
		}
	} else {
		if (lotUpgradePrice) {
			pricingArr.push({
				name: 'WOB',
				price: lotUpgradePrice,
			});
		}
		if (lotPremiumPrice) {
			pricingArr.push({
				name: 'Lot Premium',
				price: lotPremiumPrice,
			});
		}
	}

	if (lotPrice === null || lotPrice === undefined) {
		lotPrice = 0;
	}

	if (lotAvailability === 'available') {
		console.log('lotAvkailability', lotAvailability);
		let setLotToAvailableFunc = firebase
			.functions()
			.httpsCallable('setLotToAvailable');

		await setLotToAvailableFunc({
			lotId: lotId,
			projectCode: PROJECT_CODE.projectCode,
		});
	}

	console.log('THIS LOT PRICE ' + lotPrice);
	await lotRef.update({
		lotSizeType: lotSizeType ? lotSizeType : null,
		lotPrice: lotPrice,
		available: lotAvailability ? lotAvailability : null,
		closingDate: closingDate ? closingDate : null,
		pricing: pricingArr.length > 0 ? pricingArr : null,
	});

	if (oldValues.lotPrice !== lotPrice) {
		let timestamp = timestampRef.push();
		await timestamp.set({
			timestamp: Date.now(),
			value: 'lotPrice',
			oldValue: oldValues.lotPrice
				? oldValues?.lotPrice
				: oldValues?.lotPrice === 0
				? 0
				: '',
			newValue: lotPrice ? lotPrice : lotPrice === 0 ? 0 : '',
			lotId: lotId,
			alteredBy: alteredBy,
		});
	}
}

export async function updateLotsPricing(
	lotIdArr,
	{
		lotSizeType,
		lotPremiumPrice,
		lotUpgradePrice,
		lotPrice,
		lotAvailability,
		closingDate,
	},
	alteredBy
) {
	lotIdArr.map(async (lotId) => {
		let oldValues;
		let lotRef = firebaseRef.ref(
			'/kavtek_lots/' + projectCode + '/' + lotId
		);
		let timestampRef = firebaseRef.ref(
			'/kavtek_timestamps/' + projectCode + '/siteplan/lotInformation'
		);

		let pricing;
		let pricingArr = [];

		await lotRef.once('value', (snapshot) => {
			pricing = snapshot.val().pricing;
			oldValues = {
				lotPrice: snapshot.val()?.lotPrice,
			};
		});
		if (pricing) {
			pricingArr = pricing;
			if (lotUpgradePrice) {
				let index = pricingArr.findIndex(
					(element) => element.name === 'WOB'
				);
				if (index >= 0) {
					pricingArr[index].price = lotUpgradePrice;
				} else {
					pricingArr.push({
						name: 'WOB',
						price: lotUpgradePrice,
					});
				}
			}
			if (lotPremiumPrice) {
				let index = pricingArr.findIndex(
					(element) => element.name === 'Lot Premium'
				);
				if (index >= 0) {
					pricingArr[index].price = lotPremiumPrice;
				} else {
					pricingArr.push({
						name: 'Lot Premium',
						price: lotPremiumPrice,
					});
				}
			}
		} else {
			if (lotUpgradePrice) {
				pricingArr.push({
					name: 'WOB',
					price: lotUpgradePrice,
				});
			}
			if (lotPremiumPrice) {
				pricingArr.push({
					name: 'Lot Premium',
					price: lotPremiumPrice,
				});
			}
		}

		if (pricingArr.length > 0) {
			await lotRef.update({
				pricing: pricingArr,
			});
		}
		if (lotSizeType) {
			await lotRef.update({
				lotSizeType: lotSizeType,
			});
		}
		if (lotPrice) {
			await lotRef.update({
				lotPrice: lotPrice,
			});

			if (oldValues.lotPrice !== lotPrice) {
				let timestamp = timestampRef.push();
				await timestamp.set({
					timestamp: Date.now(),
					value: 'lotPrice',
					oldValue: oldValues.lotPrice
						? oldValues?.lotPrice
						: oldValues?.lotPrice === 0
						? 0
						: '',
					newValue: lotPrice ? lotPrice : lotPrice === 0 ? 0 : '',
					lotId: lotId,
					alteredBy: alteredBy,
				});
			}
		}
		if (lotAvailability) {
			await lotRef.update({
				available: lotAvailability,
			});

			console.log('lotAvkailability', lotAvailability);

			if (lotAvailability === 'available') {
				console.log('lotAvkailability', lotAvailability);
				let setLotToAvailableFunc = firebase
					.functions()
					.httpsCallable('setLotToAvailable');

				await setLotToAvailableFunc({
					lotId: lotId,
					projectCode: PROJECT_CODE.projectCode,
				});
			}
		}
		if (closingDate) {
			await lotRef.update({
				closingDate: closingDate,
			});
		}
	});
}
